import {
  Breadcrumb,
  Checkbox,
  Col,
  List,
  Row,
  Skeleton,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";

import { WeeklyListing } from "./data";

import {
  HomeOutlined,
  FolderOpenOutlined,
  FileOutlined,
} from "@ant-design/icons";
import StepsTodo from "./components/stepsTodo";
import ListingFollowup from "./components/listingFollowup";
import StillForRent from "./components/stillForRent";
import Rented from "./components/rented";
import CancelScheduledReports from "./components/cancelScheduledReports";
import EndingMgm from "./components/endingMgm";
import EndingManagment from "./components/endingManagment";
import { useParams } from "react-router-dom";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../firebase";

const { Text } = Typography;

function BiWeeklyListing({ data, alreadyCheckedItems }) {
  const { id } = useParams();

  const [itemId, setItemId] = useState(1);

  const [listId, setListId] = useState(null);
  const [checkedItems, setCheckedItems] = useState(alreadyCheckedItems || {});

  useEffect(() => {
    if (alreadyCheckedItems) {
      setCheckedItems(alreadyCheckedItems);
    }
  }, [alreadyCheckedItems]);

  const handleOnClick = (index, listId) => {
    setItemId(index);
    setListId(listId);
  };

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");
  const updateAssignedWorkItemListStatus = async (targetDocId, idStatusMap) => {
    const targetDocRef = doc(assignedCollectionRef, targetDocId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status: idStatusMap[item.id.toString()]
                ? "completed"
                : "incompleted",
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  useEffect(() => {
    const length = Object.keys(checkedItems).length;
    if (length) {
      updateAssignedWorkItemListStatus(id, checkedItems);
    }
  }, [checkedItems]);

  const handleCheckBoxClick = (e, index, itemId) => {
    // Prevent the item click from being triggered when clicking the checkbox
    e.stopPropagation();
    // Update the checked state of this item
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [itemId.toString()]: !prevCheckedItems[itemId.toString()],
    }));
  };
  return (
    <div className="make-ready">
      <Row gutter={[16, 0]}>
        <Col span={8}>
          <Row gutter={[0, 24]} className="make-ready-container">
            <Col span={24}>
              <span className="make-ready-icon">🚚</span>
            </Col>
            <Col span={24}>
              <Breadcrumb>
                <Breadcrumb.Item className="item-hover-effect">
                  <HomeOutlined /> <span>Library</span>
                </Breadcrumb.Item>
                <Breadcrumb.Item className="item-hover-effect">
                  <FolderOpenOutlined />{" "}
                  <span>Property Management Process</span>
                </Breadcrumb.Item>
                <Breadcrumb.Item className="item-hover-effect">
                  <FileOutlined /> <span>Bi-weekly listing follow up</span>
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>
            <Col span={24}>
              <Row>
                <Col>
                  <p className="heading-para">
                    E. Bi-weekly listing follow up 2:10PM workflow run
                  </p>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <List
                className="list-container"
                itemLayout="horizontal"
                dataSource={data?.workItemList}
                bordered
                renderItem={(item, index) => (
                  <List.Item
                    className="list-item"
                    onClick={() => handleOnClick(item?.id, data?.docId)}
                  >
                    <Skeleton
                      avatar
                      title={false}
                      loading={item.loading}
                      active
                    >
                      <List.Item.Meta
                        avatar={
                          <div className="item-container">
                            <span>{index + 1}. </span>
                            {item.checkBox && (
                              <Checkbox
                                onClick={(e) =>
                                  handleCheckBoxClick(e, index, item.id)
                                }
                                checked={!!checkedItems[item.id.toString()]}
                              ></Checkbox>
                            )}
                            <Text
                              strong={!item.checkBox && true}
                              delete={!!checkedItems[item.id.toString()]}
                            >
                              {item?.title}
                            </Text>
                          </div>
                        }
                      />
                    </Skeleton>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </Col>
        <Col span={16} className="right-container">
          {itemId === 1 && (
            <StepsTodo
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 2 && (
            <ListingFollowup
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 3 && (
            <StillForRent
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 4 && (
            <Rented
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 5 && (
            <CancelScheduledReports
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 6 && (
            <EndingMgm
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 7 && (
            <EndingManagment
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
        </Col>
      </Row>
    </div>
  );
}

export default BiWeeklyListing;
